import { render, staticRenderFns } from "./AddFiles.vue?vue&type=template&id=67e48ee3&"
import script from "./AddFiles.vue?vue&type=script&lang=js&"
export * from "./AddFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports